
import PropTypes from 'prop-types'
import React from 'react'
import { Form, TextField } from '@segment/react-forms'
import Space from 'ui/Space'
import Button from 'ui/Button'

const CreateBigQueryForm = props => (
  <Form onSubmit={props.onSubmit}>
    <TextField
      defaultValue={props.projectId}
      onChange={e => props.onEnterProjectId(e.target.value)}
      disabled={props.isSubmitting}
      label='Project ID'
      name='projectId'
      required />

    <Space value='40' />

    <Button type='submit' extras='fluid' disabled={!props.isValid || props.isSubmitting}>Connect</Button>
  </Form>
)

CreateBigQueryForm.displayName = 'CreateBigQueryForm'

CreateBigQueryForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  onEnterProjectId: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired
}

export default CreateBigQueryForm



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/create-bigquery-form/index.js